import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { ConfigurationService } from '../components/configuration-select/configuration.service';

@Injectable({
  providedIn: 'root',
  deps: [Router, ConfigurationService],
})
export class ConfigGuardService  {

  constructor(
    private m_router: Router,
    private m_configurationService: ConfigurationService,
  ) { }

  canActivate(p_route: ActivatedRouteSnapshot, p_state: RouterStateSnapshot): boolean {
    if (this.m_configurationService && this.m_configurationService.SelectedConfigOid) {
      return true;
    } else {
      this.m_router.navigate(['systemauswahl']);
      return false;
    }
  }
}
